const actions = require("./actions");
const cookies = require("./cookies");
const languages = require("./languages");
const paths = require("./paths");
const statusType = require("./statusType");
const clientSortTypes = require("./clientSortTypes");

module.exports.DEFAULT_START_AT = 0;
module.exports.GOOGLE_FONTS_KEY = "AIzaSyCCr3mv_jcYwOD0Ukv3-SHm2VJAIuD08Kc";
module.exports.LOGGED_ACCOUNT = "loggedUser";
module.exports.LOGGED_ADMIN = "loggedAdmin";
module.exports.MAX_CAROUSEL_LENGTH = 10;
module.exports.MAX_IMG_SIZE = 10000000;
module.exports.MIN_LENGTH_PHONE_NUMBER = 7;
module.exports.NUMBER_OF_ITEMS_PER_PAGE = 10;
module.exports.SUPPORTED_IMAGE_TYPES = ["jpg", "jpeg", "png", "svg"];
module.exports.actions = actions;
module.exports.cookies = cookies;
module.exports.languages = languages;
module.exports.paths = paths;
module.exports.statusType = statusType;
module.exports.clientSortTypes = clientSortTypes;
module.exports.SORT_BY_CREATED = "createdAt";
module.exports.transactionState = {
  Unknown: "unknown",
  Created: "created",
  GetItem: "getItem",
  DeliverItem: "deliverItem",
  Completed: "completed",
  Accepted: "accepted",
  Declined: "declined",
  Cancelled: "cancelled",
  GiveFeedback: "giveFeedback",
  Delivered: "delivered",
  ActiveDispute: "activeDispute",
  ResolveDispute: "resolveDispute",
  RejectDispute: "rejectDispute",
  ChargeFailed: "chargeFailed",
  PendingPayment: "completedPending",
  CompletedTippingMoney: "completedTippingMoney",
  CompletedChargeMoney: "completedChargeMoney"
};



// WEBPACK FOOTER //
// ./common/constants/index.js